import React, { useState, useEffect } from 'react';

import { Grid } from '@material-ui/core';
import { css } from '@emotion/react';

import styled from '@emotion/styled';
import { colors } from '@/styles';
import { ResponsiveSidebarDialog, ModalContent } from '@/styles/blocks';
import { Cancel } from '@material-ui/icons';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import IconButton from '@material-ui/core/IconButton';

export const HR = styled.div`
    width: 100%;
    margin-top: 22px;
    margin-bottom: 22px;
    border: 1px solid #e2e2e2;
`;

function ImageCoursel({ images, initialIndex, open, onClose }) {
    const [selectedIndex, setSelectedIndex] = useState(initialIndex);

    useEffect(() => {
        setSelectedIndex(initialIndex);
    }, [initialIndex]);

    if (!open || !images?.length) {
        return null;
    }

    const selectedImage = images[selectedIndex] || images[initialIndex] || images[0];

    return (
        <>
            <ResponsiveSidebarDialog
                open={open}
                onClose={() => {
                    onClose();
                }}
            >
                <ModalContent
                    css={css`
                        width: 100%;
                    `}
                >
                    <Grid container direction="column">
                        <Grid
                            item
                            css={css`
                                padding-bottom: 20px;
                                align-self: center;
                            `}
                        >
                            <img
                                src={selectedImage.url}
                                alt={selectedImage.name}
                                css={css`
                                    max-height: 500px;
                                    max-width: 650px;
                                `}
                            />
                            <Cancel
                                fontSize="large"
                                onClick={() => onClose()}
                                css={css`
                                    position: absolute;
                                    top: 10px;
                                    right: 10px;
                                    color: ${colors.greys.primary};
                                    cursor: pointer;
                                `}
                            />
                            {selectedIndex > 0 && (
                                <IconButton
                                    disableRipple
                                    css={css`
                                        position: absolute;
                                        top: 50%;
                                        left: 10px;
                                        transform: translateY(-100%);
                                        cursor: pointer;
                                        background-color: rgba(0, 0, 0, 0.5);
                                        border-radius: 50%;
                                        padding: 8px;

                                        &:hover {
                                            background-color: rgba(0, 0, 0, 1) !important;
                                        }
                                    `}
                                >
                                    <ChevronLeft
                                        fontSize="large"
                                        onClick={() => setSelectedIndex(selectedIndex - 1)}
                                        css={css`
                                            color: white;
                                        `}
                                    />
                                </IconButton>
                            )}
                            {selectedIndex < images.length - 1 && (
                                <IconButton
                                    disableRipple
                                    css={css`
                                        position: absolute;
                                        top: 50%;
                                        right: 10px;
                                        transform: translateY(-100%);
                                        cursor: pointer;
                                        background-color: rgba(0, 0, 0, 0.5);
                                        border-radius: 50%;
                                        padding: 8px;

                                        &:hover {
                                            background-color: rgba(0, 0, 0, 1) !important;
                                        }
                                    `}
                                >
                                    <ChevronRight
                                        fontSize="large"
                                        onClick={() => setSelectedIndex(selectedIndex + 1)}
                                        css={css`
                                            color: white;
                                        `}
                                    />
                                </IconButton>
                            )}
                        </Grid>
                        <Grid
                            item
                            container
                            direction="row"
                            css={css`
                                flex-wrap: nowrap;
                                overflow: scroll;
                                gap: 16px;
                                align-items: center;
                            `}
                        >
                            {images.map((img, index) => {
                                return (
                                    <Grid
                                        item
                                        key={`image-${index}`}
                                        onClick={() => setSelectedIndex(index)}
                                        css={css`
                                            border: ${selectedIndex === index
                                                ? `7px solid ${colors.greens.primary}`
                                                : 'none'};
                                        `}
                                    >
                                        <img
                                            src={img.url}
                                            alt={img.name}
                                            css={css`
                                                width: 120px;
                                            `}
                                        />
                                    </Grid>
                                );
                            })}
                        </Grid>
                    </Grid>
                </ModalContent>
            </ResponsiveSidebarDialog>
        </>
    );
}

export default ImageCoursel;
